import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const sectionStyles: SxProps<Theme> = {
    mt: 3,
};

export const cardStyles: SxProps<Theme> = {
    p: 3,
    mb: 3,
};

export const cardTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
    mb: 0.5,
};

export const cardHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 2.5,
};

/**
 * The fields inside a card.
 *
 * A column on a phone and two on anything wider. The floor is `min(260px, 100%)` rather than a
 * bare `260px`: a hard floor pushes the whole page sideways the moment the container is
 * narrower than it, which on a 375px phone inside the admin tabs it is.
 */
export const fieldGridStyles: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, minmax(min(260px, 100%), 1fr))',
    },
    gap: 2,
};

/** A field that must not share a row -- a helper under it would otherwise read as the neighbour's. */
export const fullWidthFieldStyles: SxProps<Theme> = {
    gridColumn: '1 / -1',
};

/**
 * The secret and the button that tests it, side by side on a wide screen.
 *
 * They belong together: the button is what tells the admin whether the value they just typed
 * is any good, and putting it at the bottom of the card next to Save would make it look like
 * a second way to save.
 */
export const credentialsRowStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    mt: 2,
};

/** Keeps the Test button from stretching to the width of the row it wraps onto. */
export const testButtonStyles: SxProps<Theme> = {
    flexShrink: 0,
    // Lines its baseline up with a filled text field rather than with the label above one.
    mt: 1,
};

export const switchRowStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
};

/**
 * Sits under a switch's label rather than under the switch itself, which is 42px of tap
 * target on a coarse pointer and would leave the caption looking unattached.
 */
export const switchHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    ml: 6,
    mt: -1,
    mb: 1,
};

export const actionsStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap',
};

/**
 * The line beside a disabled Save that says why it is disabled. Sixteen inputs is exactly
 * where a greyed button with no explanation is least forgivable.
 */
export const blockedSaveStyles: SxProps<Theme> = {
    color: 'error.main',
    alignSelf: 'center',
    mr: 2,
};
